import { FleetAreaCode, PermissionCode } from '@gb-ticket/shared-types';
import { Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { OverflowTabNav, type OverflowTabItem } from '@/platform/components/overflow-tab-nav';
import { fleetAreaOn, useFleetAreas } from '@/products/fleet/features/use-fleet-areas';
import {
  FLEET_OPERATIONS_CHARGE_PATH,
  FLEET_OPERATIONS_COSTS_PATH,
  FLEET_OPERATIONS_FUEL_PATH,
  FLEET_OPERATIONS_MAP_PATH,
} from '@/products/fleet/fleet-paths';

export function FleetOperationsLayout() {
  const me = useMe();
  const areas = useFleetAreas();
  const catalog = areas.isError ? undefined : areas.data;
  const fuelRead = hasPermission(me.data, PermissionCode.FLEET_FUEL_READ);
  const workshop = hasPermission(me.data, PermissionCode.FLEET_WORKSHOP_MANAGE);
  const telematicsRead = hasPermission(me.data, PermissionCode.FLEET_TELEMATICS_READ);
  const showMap = telematicsRead && fleetAreaOn(catalog, FleetAreaCode.TELEMATICS);
  const showFuel = fuelRead && fleetAreaOn(catalog, FleetAreaCode.FUEL);
  const showCosts =
    (workshop && fleetAreaOn(catalog, FleetAreaCode.WORKSHOP)) ||
    (fuelRead && fleetAreaOn(catalog, FleetAreaCode.FUEL));

  const items: OverflowTabItem[] = [
    ...(showMap
      ? [
          { to: FLEET_OPERATIONS_MAP_PATH, label: 'Karte' },
          { to: FLEET_OPERATIONS_CHARGE_PATH, label: 'Laden' },
        ]
      : []),
    ...(showFuel ? [{ to: FLEET_OPERATIONS_FUEL_PATH, label: 'Tankkarten' }] : []),
    ...(showCosts ? [{ to: FLEET_OPERATIONS_COSTS_PATH, label: 'Kosten' }] : []),
  ];

  return (
    <div className="space-y-6">
      <OverflowTabNav ariaLabel="Betrieb" items={items} />
      <Outlet />
    </div>
  );
}
